module.exports = __webpack_public_path__ + "static/media/carshowz_show.dab492de.png";